import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { of } from 'rxjs';
import { first, switchMap, tap } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { ClientService } from '../../../domain/services/client.service';
import { ChangesNotSavedComponent } from '../../../shared/changes-not-saved';
import { BackgroundFormComponent } from '../../components';
import { Application } from '../../models';
import { applicationPresent } from '../../operators';
import { CurrentApplicationService } from '../../services';
import { ApplicationService } from './../../../application/services';

@Component({
    selector: 'app-background',
    templateUrl: './background.component.html',
    styleUrls: ['./../../application-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BackgroundComponent
    extends ChangesNotSavedComponent
    implements OnInit
{
    submitted = false; // because we are extending ChangesNotSavedComponent

    yearPlaceHolder = new Date().getFullYear();

    fields$ = this._client.latest.pipe(
        switchMap((client) => this._client.getClientFields(2))
    );

    formValue$ = this._currentApplication.latest.pipe(
        applicationPresent(),
        first(),
        switchMap((application: Application) => {
            if (application?.applicationId) {
                return this.applicationService.getBackground(
                    application.applicationId!
                );
            } else return of(null);
        })
    );

    @ViewChild(BackgroundFormComponent) form:
        | BackgroundFormComponent
        | undefined;

    constructor(
        private readonly applicationService: ApplicationService,
        private readonly router: Router,
        private readonly _transloco: TranslocoService,
        private readonly _currentApplication: CurrentApplicationService,
        private readonly snackBar: MatSnackBar,
        private readonly _client: ClientService,
        private readonly _googleAnalyticsService: GoogleAnalyticsService
    ) {
        super();
    }

    ngOnInit() {
        this._googleAnalyticsService.pageView('Application: Background');
    }

    onSubmitted(background: any) {
        this.applicationService
            .saveBackground(background)
            .pipe(
                switchMap(() =>
                    this._transloco
                        .selectTranslate('application.snack.saved')
                        .pipe(first())
                ),

                tap((message) => {
                    this.snackBar.open(message, undefined, {
                        duration: 4000
                    });
                    this.postSubmit();
                })
            )
            .subscribe();
    }

    postSubmit() {
        this.submitted = true;
        this._currentApplication.load();
        this.router.navigateByUrl(
            `${runtimeConfig.clientCode}/application/your-education`
        );
    }

    isChanged(): boolean {
        return this.form?.touched ?? false;
    }

    isSaved(): boolean {
        return this.submitted;
    }
}
